import { render, staticRenderFns } from "./taikuang.vue?vue&type=template&id=8751b112&scoped=true"
import script from "./taikuang.vue?vue&type=script&lang=js"
export * from "./taikuang.vue?vue&type=script&lang=js"
import style0 from "./taikuang.vue?vue&type=style&index=0&id=8751b112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8751b112",
  null
  
)

export default component.exports